import ApiClient from '@afosto/api/ApiClient';

class Files {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create an upload signature
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Returns a new upload signature
   * @returns {Promise}
   */
  createSignedUrl(body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/files/signature`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete a file
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Deletes a file
   * @returns {Promise}
   */
  deleteFile(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/files/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get a file
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a file
   * @returns {Promise}
   */
  getFile(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/files/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get list of files
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.dir]
   * @param {string} [query.isPublic]
   * @param {Object} options - The additional request options
   * @description Returns a list of files
   * @returns {Promise}
   */
  listFiles(query = {}, options = {}) {
    const params = {
      dir: query.dir,
      is_public: query.isPublic,
    };

    return this.apiClient.request({
      url: `/cnt/files`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Upload a file
   *
   * @param {string} signature
   * @param {Object} file
   * @param {Object} options - The additional request options
   * @description Upload a new file
   * @returns {Promise}
   */
  uploadFile(signature, file, options = {}) {
    return this.apiClient.request({
      url: `/cnt/files/upload/${signature}`,
      method: 'post',
      data: file,
      ...options,
    });
  }
}

export const files = new Files();

export default Files;
